import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
// import { editReportAction } from "../../../../store/actions/ReportAction";
import { editReportAction, getReportsAction, deleteReportFileAction } from "../../../../../store/actions/ReportAction";
// import { showErrorAlert } from "../../../../services/ErrorHandlingService";
// import FormSuccessMessage from "../../Common/FormSuccessMessage";
import FormSuccessMessage from "../../../Common/FormSuccessMessage";

const EditReportForm = ({ report, onClose, patientId }) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    reportTitle: report.report_title,
    reportDescription: report.report_description,
    reportDate: report.report_date ? report.report_date : "",
  });

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewList, setPreviewList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [removedFiles, setRemovedFiles] = useState([]);
  const [localFiles, setLocalFiles] = useState(report.report_files || []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);

    const previews = files.map((file) => ({
      name: file.name,
      type: file.type === "application/pdf" ? "pdf" : "image",
      url: file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null,
    }));

    setPreviewList(previews);
  };

  console.log("Files to delete:", removedFiles);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const form = new FormData();

      form.append("report_id", report.report_id);
      form.append("patient_id", patientId);
      form.append("report_title", formData.reportTitle);
      form.append("report_description", formData.reportDescription);
      form.append("report_date", formData.reportDate);

      // new files
      selectedFiles.forEach((file) => {
        form.append("report_file[]", file);
      });

      // files to remove
      removedFiles.forEach((id) => {
        form.append("delete_file_ids[]", id);
      });

      const response = await dispatch(editReportAction(form));

      if (response?.status === 200) {
        await dispatch(getReportsAction(patientId)); // 👈 refresh data
        setIsUpdated(true);
        setTimeout(() => onClose(), 1500);
      }

    } catch (error) {
      console.error("Update failed:", error);
    }

    setLoading(false);
  };

  // if (isUpdated) {
  //   return (
  //     <FormSuccessMessage
  //       title="Report Updated"
  //       message="Report details have been successfully updated."
  //     />
  //   );
  // }

  return (
    <Form onSubmit={handleSubmit}>


      <Form.Group className="mb-3">
        <Form.Label>Report Title</Form.Label>
        <Form.Control
          type="text"
          name="reportTitle"
          value={formData.reportTitle}
          onChange={handleInputChange}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Report Date</Form.Label>
        <Form.Control
          type="date"
          name="reportDate"
          value={formData.reportDate || ""}
          onChange={handleInputChange}
          required
        />
      </Form.Group>

      {/* FILE INPUT */}
      <Form.Group className="mb-3">
        <Form.Label>Add File </Form.Label>
        <Form.Control
          type="file"
          multiple
          onChange={handleFileChange}
          accept=".pdf,.jpg,.jpeg,.png"
        />
        <Form.Text className="text-muted">

        </Form.Text>
      </Form.Group>
      {/* EXISTING FILE PREVIEW */}
      {/* {report?.report_files?.length > 0 && (
        <div className="mb-3">
          <Form.Label>Current Files</Form.Label>

          <div className="d-flex flex-wrap gap-3">
            {report.report_files
              .filter(file => !removedFiles.includes(file.id))
              .map((file, index) => {
                console.log("FILE OBJECT:", file); 

                const fileUrl = file.report_file_url || file.url;
                const isPDF = fileUrl?.toLowerCase().endsWith(".pdf");

                return (
                  <div key={index} style={{ position: "relative" }}>

                    
                    <span
                      onClick={async () => {
                        try {
                          await dispatch(deleteReportFileAction(file.report_file_id));

                          
                          setLocalFiles(prev =>
                            prev.filter(f => f.report_file_id !== file.report_file_id)
                          );

                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      style={{
                        position: "absolute",
                        top: "-6px",
                        right: "-6px",
                        background: "red",
                        color: "white",
                        borderRadius: "50%",
                        width: "18px",
                        height: "18px",
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer"
                      }}
                    >
                      ×
                    </span>

                    {isPDF ? (
                      <i
                        className="las la-file-pdf"
                        style={{ fontSize: "40px", color: "red", cursor: "pointer" }}
                        onClick={() => window.open(fileUrl, "_blank")}
                      ></i>
                    ) : (
                      <img
                        src={fileUrl}
                        alt="existing"
                        style={{
                          width: "100px",
                          height: "80px",
                          objectFit: "cover",
                          borderRadius: "6px",
                          cursor: "pointer"
                        }}
                        onClick={() => window.open(fileUrl, "_blank")}
                      />
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      )} */}

      {localFiles.length > 0 && (
        <div className="mb-3">
          <Form.Label>Current Files</Form.Label>

          <div className="d-flex flex-wrap gap-3">
            {localFiles.map((file, index) => {

              const fileUrl = file.report_file_url || file.url;
              const isPDF = fileUrl?.toLowerCase().endsWith(".pdf");

              return (
                <div key={index} style={{ position: "relative" }}>

                  <span
                    onClick={async () => {
                      await dispatch(deleteReportFileAction(file.report_file_id));

                      setLocalFiles(prev =>
                        prev.filter(f => f.report_file_id !== file.report_file_id)
                      );
                    }}
                    style={{
                      position: "absolute",
                      top: "-6px",
                      right: "-6px",
                      background: "red",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer"
                    }}
                  >
                    ×
                  </span>

                  {isPDF ? (
                      <i
                        className="las la-file-pdf"
                        style={{ fontSize: "40px", color: "red", cursor: "pointer" }}
                        onClick={() => window.open(fileUrl, "_blank")}
                      ></i>
                    ) : (
                      <img
                        src={fileUrl}
                        alt="existing"
                        style={{
                          width: "100px",
                          height: "80px",
                          objectFit: "cover",
                          borderRadius: "6px",
                          cursor: "pointer"
                        }}
                        onClick={() => window.open(fileUrl, "_blank")}
                      />
                    )}
                </div>
              );
            })}
          </div>
        </div>
      )}
      {/* NEW SELECTED FILE PREVIEW */}
      {previewList.length > 0 && (
        <div className="mb-3">
          <Form.Label>New Selected Files</Form.Label>

          <div className="d-flex flex-wrap gap-3">
            {previewList.map((file, index) =>
              file.type === "pdf" ? (
                <div key={index}>
                  <i
                    className="las la-file-pdf"
                    style={{ fontSize: "40px", color: "red" }}
                  ></i>
                </div>
              ) : (
                <img
                  key={index}
                  src={file.url}
                  alt="preview"
                  style={{
                    width: "100px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "6px",
                  }}
                />
              )
            )}
          </div>
        </div>
      )}


      <Form.Group className="mb-3">
        <Form.Label>Report Description</Form.Label>
        <Form.Control
          type="text"
          name="reportDescription"
          value={formData.reportDescription}
          onChange={handleInputChange}
        />
      </Form.Group>


      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? "Updating..." : "Update Report"}
        </Button>
      </div>
    </Form>
  );
};

export default EditReportForm;
